<template>
  <div class='h100vh-116'>
    <div class='h-mml-leftinputbox'>
      <div class='h-mml-inputbigbox'>
        <ejs-textbox :placeholder='SearchHolder' v-model='keywords'></ejs-textbox>
      </div>
    </div>
    <div class='h100-40'>
      <ne-list ref='mmlNeList' :ne-datas='neDataFiltered' :dev-datas='devDataFiltered' :cluster-datas='clusterDataFiltered'></ne-list>
    </div>
  </div>
</template>
<script>
import NeList from '@/components/mmlconfig/leftPanel/NeList.vue';

export default {
  name: 'left-panel',
  components: {
    NeList
  },
  data() {
    return {
      SearchHolder: this.$t('MML.searchHolder'),
      keywords: '',
      primaryNeDatas: [],
      primaryDevDatas: [],
      primaryClusterDatas: [],
      // clusterShowFlag: false,
      // devShowFlag: true,
      itemData: [
        { header:{text: this.$t('UE.legend_bs')}, content: '#mml-dev-list'},
        // { header: {text:this.$t('MML.ne')}, content: '#mml-ne-list'},

      ],
    };
  },
  computed: {
    neDataFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return this.primaryNeDatas;
      }
      return this.primaryNeDatas.filter(neData => (neData.name.toLowerCase().includes(trimedKeyWords)
        || (neData.Subnet && neData.Subnet.toLowerCase().includes(trimedKeyWords))));
    },
    devDataFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return this.primaryDevDatas;
      }
      return this.primaryDevDatas.filter(devData => (devData.name.toLowerCase().includes(trimedKeyWords)
        || (devData.Subnet && devData.Subnet.toLowerCase().includes(trimedKeyWords))));
    },
    clusterDataFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return this.primaryClusterDatas;
      }
      return this.primaryClusterDatas.filter(clusterData => (clusterData.name.toLowerCase().includes(trimedKeyWords)
        || (clusterData.Subnet && clusterData.Subnet.toLowerCase().includes(trimedKeyWords))));
    },
  },
  created() {
    this.$axios.get(`/lte/ems/install/getInstallProducts`).then((response) => {
      if(response.status == 200) {
        if (response.data) {
          const productList = response.data;
          //EPC可以和微服务共存
          const devProductList = productList.filter(item => item !== "9");
          for (var i = 0; i < productList.length; i++) {
            if (productList[i] === "9") {//微服务有集群,没有设备
              if (devProductList && devProductList.length === 0) {
                this.itemData.splice(1,1);
              }
              this.itemData.push( { header: {text:this.$t('MML.cluster')}, content: '#mml-cluster-list'});
            }

          }
        }
      }
      this.$refs.mmlNeList.initTabs(this.itemData);
    });
    this.axios.get('/lte/ems/auth/queryAllNodesByAuth').then(res => {
      const nodeMap = res.data;
      const neInfoArr = nodeMap.NetElement.sort((a, b) => (a.equipmentId - b.equipmentId));
      neInfoArr.forEach(neInfo => {
        neInfo.name = `${neInfo.name.trim()}`;
        neInfo.toolTip = `${this.$t('MML.elementName')}${neInfo.name.trim()}\n${this.$t('MML.equipmentName')}${neInfo.equipmentName.trim()}`;
        if(neInfo.ip) {
          neInfo.toolTip += `\n${this.$t('MML.equipmentIp')}${neInfo.ip}`;
        }
        if(neInfo.Subnet) {
          neInfo.toolTip += `\n${this.$t('MML.subnetInfo')}${neInfo.Subnet}`;
        }
        if(neInfo.envName) {
          neInfo.toolTip += `\n${this.$t('MML.environmentName')}${neInfo.envName}`;
        }
        neInfo.id = neInfo.id;
        neInfo.icon = `icon hero-icon ${neInfo.icon} h-pm-icon4mml`;
      });
      this.primaryNeDatas = neInfoArr;
      console.log(this.primaryNeDatas);
      const devInfoArr = nodeMap.Equipment; //调整位后台排序
      devInfoArr.forEach(devInfo => {
        devInfo.name = devInfo.name.trim();
        devInfo.toolTip = `${this.$t('MML.equipmentName')}${devInfo.name.trim()}`;
        if(devInfo.ip) {
          devInfo.toolTip += `\n${this.$t('MML.equipmentIp')}${devInfo.ip}`;
        }
        if(devInfo.Subnet) {
          devInfo.toolTip += `\n${this.$t('MML.subnetInfo')}${devInfo.Subnet}`;
        }
        devInfo.id = devInfo.id;
        devInfo.icon = `icon hero-icon ${devInfo.icon} h-pm-icon4mml`;
      })
      this.primaryDevDatas = devInfoArr;

      const clusterInfoArr = nodeMap.Cluster.sort((a, b) => (a.id - b.id));
      clusterInfoArr.forEach(clusterInfo => {
        clusterInfo.name = clusterInfo.name.trim();
        clusterInfo.toolTip = clusterInfo.envName?`${this.$t('MML.environmentName')}${clusterInfo.envName.trim()}`:`${this.$t('MML.elementName')}${clusterInfo.name.trim()}`;;
        // clusterInfo.toolTip = `${this.$t('MML.environmentName')}${clusterInfo.name.trim()}`;
        if(clusterInfo.ip) {
          clusterInfo.toolTip += `\n${this.$t('MML.equipmentIp')}${clusterInfo.ip}`;
        }
        if(clusterInfo.Subnet) {
          clusterInfo.toolTip += `\n${this.$t('MML.subnetInfo')}${clusterInfo.Subnet}`;
        }
        clusterInfo.id = clusterInfo.id;
        clusterInfo.icon = `icon hero-icon ${clusterInfo.icon} h-pm-icon4mml`;
      })

      this.primaryClusterDatas = clusterInfoArr;

    });
  },
  methods: {
    showStatus() {
      this.$axios.get(`/lte/ems/install/getInstallProducts`).then((response) => {
          if(response.status == 200) {
            if (response.data) {
              const productList = response.data;
              for (var i = 0; i < productList.length; i++) {
                if (productList[i] === "9") {//微服务有集群,没有设备
                  this.devShowFlag = false;
                  this.clusterShowFlag = true;
                  break;
                }
              }
            }
          }
      });
    }
  }
};
</script>

<style>

</style>
